import React from "react";
import { useI18n } from "../i18n/I18nContext";

export function Logo({ className = "", showText = true, height = 44 }) {
  const { isAr } = useI18n();
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img src="/logo-motawahj.png" alt="متوهج | Motawahj"
           style={{ height }} className="w-auto object-contain" />
    </div>
  );
}
